import React, { forwardRef } from 'react'
import useRouter from 'utils/useRouter'
import clsx from 'clsx'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles } from '@material-ui/styles'
import { Card, CardHeader, CardContent, Grid, Divider } from '@material-ui/core'
import MaterialTable from 'material-table'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import { useGerenciamentoBalisticaService } from 'hooks/useGerenciamentoBalisticaService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 700,
  },
}))

export const Results = (props) => {
  const { className, dados, ...rest } = props
  const classes = useStyles()
  const gerenciamentoBalisticaService = useGerenciamentoBalisticaService()
  const router = useRouter()
  moment.locale('pt-br', localization)

  const handleRowClick = async (modeloBalistico) => {
    await gerenciamentoBalisticaService.setModeloBalisticoGlobal(modeloBalistico)
    await gerenciamentoBalisticaService.listarDadosItensBalisticosGlobal(modeloBalistico.modelo)
    router.history.push('/gerenciamentoBalistica/dadoGerenciavel')
  }

  return (
    <div>
      <div {...rest} className={clsx(classes.root, className)}>
        <Card {...rest} className={clsx(classes.root, className)}>
          <CardContent>
            <div>
              <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
                <Grid item>
                  <CardHeader title="DADOS BALÍSTICOS UTILIZADOS NOS FORMULÁRIO DE EXAME" />
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <MaterialTable
                    localization={{
                      pagination: {
                        labelDisplayedRows: '{from}-{to} de {count}',
                        labelRowsSelect: 'linhas',
                        nextTooltip: 'Página seguinte',
                        previousTooltip: 'Página anterior',
                        lastTooltip: 'Última página',
                        firstTooltip: 'Primeira página',
                      },
                      toolbar: {
                        nRowsSelected: '{0} linha(s) selecionadas',
                        searchPlaceholder: 'Buscar',
                      },
                      header: {
                        actions: 'Ações',
                      },
                      body: {
                        emptyDataSourceMessage: 'Nada para mostrar',
                        filterRow: {
                          filterTooltip: 'Filtro',
                        },
                      },
                    }}
                    title=""
                    columns={[
                      {
                        title: 'Nome',
                        field: 'nome',
                      },
                    ]}
                    data={dados}
                    icons={{
                      DetailPanel: forwardRef((propsDetailPanel, ref) => (
                        <ArrowForwardIosIcon {...propsDetailPanel} ref={ref} />
                      )),
                      SortArrow: forwardRef((propsSortArrow, ref) => (
                        <ArrowDownwardIcon {...propsSortArrow} ref={ref} />
                      )),
                      Search: forwardRef((propsSearch, ref) => (
                        <SearchIcon {...propsSearch} ref={ref} />
                      )),
                      ResetSearch: forwardRef((propsResetSearch, ref) => (
                        <ClearIcon {...propsResetSearch} ref={ref} />
                      )),
                      NextPage: forwardRef((propsNextPage, ref) => (
                        <NavigateNextIcon {...propsNextPage} ref={ref} />
                      )),
                      PreviousPage: forwardRef((propsPreviousPage, ref) => (
                        <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />
                      )),
                      FirstPage: forwardRef((propsFirstPage, ref) => (
                        <FirstPageIcon {...propsFirstPage} ref={ref} />
                      )),
                      LastPage: forwardRef((propsLastPage, ref) => (
                        <LastPageIcon {...propsLastPage} ref={ref} />
                      )),
                    }}
                    onRowClick={(event, rowData) => handleRowClick(rowData)}
                    options={{
                      actionsColumnIndex: -1,
                      search: true,
                      pageSize: 10,
                      searchFieldStyle: {
                        flexGrow: 1,
                        height: 42,
                        // padding: theme.spacing(0, 2),
                        display: 'flex',
                        alignItems: 'center',
                      },
                      headerStyle: {
                        backgroundColor: '#f4f6f8',
                      },
                    }}
                    style={{
                      padding: '16px',
                      fontSize: '14px',
                      textAlign: 'left',
                      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                      fontWeight: '400',
                      lineHeight: '21px',
                      borderBottom: '1px solid #eeeeee',
                      letterSpacing: '-0.05px',
                      verticalAlign: 'inherit',
                    }}
                  />
                </div>
              </PerfectScrollbar>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
